import Vue from 'vue'
import moment from 'moment'

// MAESTRO

Vue.filter('maestroParamLabel', function (param) {
	let name = param.name.split('_').map(word => {
		return word.charAt(0).toUpperCase() + word.slice(1)
	}).join(' ')
	if (param.required) return name + ' *'
	if (!param.hasOwnProperty('required')) return name + ' *'
	return name
})

Vue.filter('maestroParamLabelHelp', function (param) {
	let name = ''
	if (param.help) {
		name = param.help
	} else {
		name = param.name.split('_').map(word => {
			return word.charAt(0).toUpperCase() + word.slice(1)
		}).join(' ')
	}
	if (param.required) return name + ' *'
	if (!param.hasOwnProperty('required')) return name + ' *'
	return name
})

// DATE

Vue.filter('formatDate', function (value) {
	if (value) {
		return moment(String(value)).format('YYYY/MM/DD HH:mm:ss')
	}
})

Vue.filter('formatDate2', function (value) {
	if (value) {
		return moment(String(value)).format('DD/MM/YYYY à HH:mm')
	}
	return '-'
})

Vue.filter('formatDateNoSep', function (value) {
	if (value) {
		return moment(String(value)).format('DD/MM/YYYY HH:mm')
	}
	return '-'
})

Vue.filter('formatDateNoTime', function (value) {
	if (value) {
		return moment(String(value)).format('DD/MM/YYYY')
	}
	return '-'
})

Vue.filter('formatDateDuration', function (value) {
	if (value) {
		let time = value.split('T')[1]
		if (!time) return '-'
		return moment.duration(time).humanize('HH:mm:ss')
	}
	return '-'
})

// WEIGHT

Vue.filter('humanizeBytes1000', function (value) {
	if (!value) return '-'
	if (isNaN(parseInt(value))) return '-'
	let unit = 'o'
	if (String(value).length < 4) return value + ' ' + unit
	if (String(value).length < 7) {
		return Math.round(value / Math.pow(1000, 1) * 100) / 100 + ' K' + unit
	}
	if (String(value).length >= 7 && String(value).length < 10) {
		return Math.round(value / Math.pow(1000, 2) * 100) / 100 + ' M' + unit
	}
	if (String(value).length >= 10 && String(value).length < 13) {
		return Math.round(value / Math.pow(1000, 3) * 100) / 100 + ' G' + unit
	}
	if (String(value).length >= 13 && String(value).length < 16) {
		return Math.round(value / Math.pow(1000, 4) * 100) / 100 + ' T' + unit
	}
	if (String(value).length >= 16) {
		return Math.round(value / Math.pow(1000, 5) * 100) / 100 + ' P' + unit
	}
	return 'N/A'
})

Vue.filter('humanizeBytes1024', function (value) {
	if (!value) return '-'
	if (isNaN(parseInt(value))) return '-'
	let unit = 'io'
	if (String(value).length < 4) return value + ' ' + unit
	if (String(value).length < 7) {
		return Math.round(value / Math.pow(1024, 1) * 100) / 100 + ' K' + unit
	}
	if (String(value).length >= 7 && String(value).length < 10) {
		return Math.round(value / Math.pow(1024, 2) * 100) / 100 + ' M' + unit
	}
	if (String(value).length >= 10 && String(value).length < 13) {
		return Math.round(value / Math.pow(1024, 3) * 100) / 100 + ' G' + unit
	}
	if (String(value).length >= 13 && String(value).length < 16) {
		return Math.round(value / Math.pow(1024, 4) * 100) / 100 + ' T' + unit
	}
	if (String(value).length >= 16) {
		return Math.round(value / Math.pow(1024, 5) * 100) / 100 + ' P' + unit
	}
	return 'N/A'
})

// SUPPORT

Vue.filter('ticketStatus', function (value) {
	let obj = window.vm.$getConst('TICKETS_STATUS').find(s => s.value === value)
	if (obj) return obj.label
	return value
})

Vue.filter('ticketProject', function (value) {
	let obj = window.vm.$Projects.find(s => s.value === value)
	if (obj) return obj.text
	return value
})

Vue.filter('ticketCategory', function (value) {
	let obj = window.vm.$SupportCats.find(s => s.value === value)
	if (obj) return obj.text
	return value
})

Vue.filter('substring', function (value, start, end) {
	let filtered = value.substring(start, end)
	if (value.length > filtered.length) filtered += '...'
	return filtered
})

// TYPO

Vue.filter('titleCase', function (string) {
	return string.replace(/\w\S*/g, function (txt) {
		return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
	})
})

Vue.filter('snakeCase', function (string) {
	return string.charAt(0).toUpperCase() + string.split('_').join(' ').slice(1)
})

Vue.filter('titleize', function (string) {
	return string.charAt(0).toUpperCase() + string.slice(1)
})

Vue.filter('capitalize', function (string) {
	let split_str = string.split(' ')
	let capitalized = split_str.map(word => {
		return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
	})
	return capitalized.join(' ')
})

Vue.filter('spacedTitleCase', function (string) {
	return string.split(/[\s_]/).map(word => {
		return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
	}).join(' ')
})

Vue.filter('label_required', function (value, required) {
	let label = value
	if (required) label += ' *'
	return label
})

Vue.filter('emailToName', function (email) {
	return email
		.split('@')[0]
		.split('.')
		.map(part => part.charAt(0).toUpperCase() + part.slice(1))
		.join(' ')
})

// PATHS

Vue.filter('fileBasename', function (path) {
	if (!path) return ''
	return path.split('/').pop()
})



// WEBPACK FOOTER //
// ./src/plugins/filters.js